import {reduxForm} from 'redux-form';
import {push} from 'react-router-redux/lib/actions';
import config from 'config';
import validate from '../../../utilites/validate';
import FanBoxMessages from '../../../api/fanboxMessages';
import FanBoxMessageForm from './FanBoxMessageForm';
import fanBoxMessagesAction from '../../../actions/fanboxMessages';
import {getCurrentClubId} from '../../../selectors/club-settings';

import { ROUTE_FAN_BOX_MESSAGE_ROOT } from './../constants';

const validateForm = (data) => {
  let {title, content} = FanBoxMessages.validateConstraints;
  return validate(data, {title, content}) || {};
};

export default reduxForm(
  {
    form: 'fan_box_message_form',
    fields: ['title', 'content', 'short_content', 'image', 'vip', 'club_id', 'video'],
    returnRejectedSubmitPromise: true,
    validate: validateForm,
    asyncBlurFields: ['image'],
    asyncValidate: async(data) => {
      await validate.async(data, {
        image: {
          minImageSizeAsync: config.fanBoxMessageCrop
        }
      });

      return {};
    }
  },
  (state) => ({
    model: state.fanBoxMessages.model,
    isAbleToDelete: state.fanBoxMessages.model && !state.fanBoxMessages.model.isNew(),
    isPublished: state.fanBoxMessages.model && state.fanBoxMessages.model.published,
    initialValues: Object.assign({
        vip: true,
        club_id: getCurrentClubId(state)
      }, state.fanBoxMessages.model
        ? {
        title: state.fanBoxMessages.model.title,
        content: state.fanBoxMessages.model.content,
        short_content: state.fanBoxMessages.model.short_content,
        image: state.fanBoxMessages.model.image,
        video: state.fanBoxMessages.model.video,
        vip: state.fanBoxMessages.model.vip,
        club_id: state.fanBoxMessages.model.club_id || getCurrentClubId(state)
      }
        : {}
    )
  }),
  dispatch => ({
    save: (item, data) => dispatch(fanBoxMessagesAction.save(item, data)),
    onCloseEditForm: () => dispatch(fanBoxMessagesAction.onCloseEditForm()),
    goIndex: () => dispatch(push(ROUTE_FAN_BOX_MESSAGE_ROOT))
  })
)(FanBoxMessageForm);



// WEBPACK FOOTER //
// ./src/components/FanBox/FanBoxMessageForm/index.js